module.exports = __webpack_public_path__ + "img/bulleit_logo.ecfd24ac.png";